import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class MassIndexSeries extends Component {
  static yExtents(datum, index, allData, indicator) {
    const dataArr = Array.isArray(allData)
      ? allData
      : Array.isArray(datum)
        ? datum
        : [datum];

    if (!indicator || !indicator.renderKey) {
      return undefined;
    }

    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;

    dataArr.forEach((item) => {
      const value = item && item[indicator.renderKey];
      if (Number.isFinite(value)) {
        if (value < min) min = value;
        if (value > max) max = value;
      }
    });

    // If no valid data, return undefined
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      return undefined;
    }

    // Always include the bulge threshold in the range
    const bulgeThreshold = indicator.options
      ? indicator.options().bulgeThreshold
      : 27;
    min = Math.min(min, bulgeThreshold || 27);
    max = Math.max(max, bulgeThreshold || 27);

    // Add 10% padding
    const range = max - min;
    const padding = range * 0.1;

    return [min - padding, max + padding];
  }

  render() {
    const {
      yAccessor,
      stroke,
      strokeThresholdLine,
      bulgeThreshold,
      className,
      ...rest
    } = this.props;

    return (
      <g className={className}>
        <LineSeries {...rest} yAccessor={yAccessor} stroke={stroke} />
        <StraightLine yValue={bulgeThreshold} stroke={strokeThresholdLine} />
      </g>
    );
  }
}

MassIndexSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.object.isRequired,
  strokeThresholdLine: PropTypes.object,
  bulgeThreshold: PropTypes.number,
  className: PropTypes.string,
  clip: PropTypes.bool,
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

MassIndexSeries.defaultProps = {
  strokeThresholdLine: {
    color: "#FF6B6B",
    dash: "Dash",
    width: 1,
    opacity: 0.7,
  },
  bulgeThreshold: 27,
  className: "react-stockcharts-massindex",
  clip: true,
};

export default MassIndexSeries;
